<h2 id="faq">Veelgestelde vragen</h2>

<div class="[ flex flex-wrap items-center justify-center gap-m ]">
  <dcr-card hero-type="image" class="flex-1">
    <dcr-image slot="hero" src="assets/images/faq/student.svg" loading="lazy"></dcr-image>
    <div slot="actions" class="justify-center">
      <dcr-outline-button
        label="voor leerlingen"
        trailing-icon="actions:trending_flat"
        href="/faq?role=student"
      ></dcr-outline-button>
    </div>
  </dcr-card>
  <dcr-card hero-type="image" class="flex-1">
    <dcr-image slot="hero" src="assets/images/faq/teacher.svg" loading="lazy"></dcr-image>
    <div slot="actions" class="justify-center">
      <dcr-outline-button
        label="voor leerkrachten"
        trailing-icon="actions:trending_flat"
        href="/faq?role=teacher"
      ></dcr-outline-button>
    </div>
  </dcr-card>
  <dcr-card hero-type="image" class="flex-1">
    <dcr-image slot="hero" src="assets/images/faq/schooladmin.svg" loading="lazy"></dcr-image>
    <div slot="actions" class="justify-center">
      <dcr-outline-button
        label="voor beheerders"
        trailing-icon="actions:trending_flat"
        href="/faq?role=schooladmin"
      ></dcr-outline-button>
    </div>
  </dcr-card>
</div>
